export function FilledChatIcon({ className }: { className?: string }) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      className={className}
    >
      <path
        d="M25.6666 19.8333C25.6666 21.1211 24.6211 22.1667 23.3333 22.1667H7.96592C7.34713 22.1668 6.75373 22.4127 6.31625 22.8503L3.74725 25.4193C3.51035 25.6562 3.15411 25.727 2.84461 25.5988C2.53511 25.4707 2.3333 25.1687 2.33325 24.8337V5.83333C2.33325 4.54553 3.37878 3.5 4.66659 3.5H23.3333C24.6211 3.5 25.6666 4.54553 25.6666 5.83333V19.8333"
        stroke="currentColor"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.16675 12.8333H19.8334"
        stroke="currentColor"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.16675 17.5H15.1667"
        stroke="currentColor"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.16675 8.16666H17.5001"
        stroke="currentColor"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
